module.exports = __webpack_public_path__ + "img/20191029164902542.bc28331f.jpg";